<template>
  <div id="campaign-brief">
    <section class="content">
      <div class="box" style="border-top:none">
        <div class="box-header">
          <v-btn rounded small color="secondary" @click="paginate(1)">
            <i
              class="fa fa-repeat"
              data-toggle="tooltip"
              data-placement="top"
              title="Reload Campaigns"
            ></i>
          </v-btn>
        </div>
        <!-- <v-alert type="info">
          If you are unable to access your campaign brief, please proceed to update
          <strong>
            <a class="white--text" href="mailto:finance@getkobe.com">finance@getkobe.com</a>
          </strong> for payment status update.
        </v-alert> -->
        <div class="box-body">
          <v-data-table
            :headers="fields"
            :items="campaigns"
            :items-per-page="itemsPerPage"
            class="elevation-1"
            data-app
          >
            <template v-slot:[`item.action`]="{item}">
              <td class="layout px-0">
                <!-- View Campagign Detail -->
                <v-btn
                  color="info"
                  class="ims-action"
                  data-toggle="modal"
                  data-target="#view_campaign_modal"
                  :disabled="(item.activated === campaignActivationStatusConfig.ACTIVATED)? false : true"
                  @click="getCampaignDataToView(item.id)"
                >
                  <v-icon small data-toggle="tooltip" data-placement="top" title="View Campaign">remove_red_eye</v-icon>
                </v-btn>
                <!-- View Campaign Approval -->
                <v-btn
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Accept Campaign"
                  @click="approveCampaign(item.id)"
                  color="success"
                  class="ims-action"
                  v-if="item.status === campaignStatusConfig.PENDING_CLIENT_APPROVAL"
                  :disabled="item.activated === campaignActivationStatusConfig.ACTIVATED ? false : true"
                >
                  <v-icon color="white" small>done</v-icon>
                </v-btn>
                <!-- View Elimination -->
                <v-btn
                  color="secondary"
                  class="ims-action"
                  :disabled="item.activated === campaignActivationStatusConfig.ACTIVATED ? false : true"
                  @click="startEliminate(item.id, item.status)"
                >
                  <i class="fas fa-users-cog" data-toggle="tooltip" data-placement="top" title="View Pairing Influencers"></i>
                </v-btn>
                <!-- View influencer list -->
                <!-- <v-btn
                  v-if="buttonShow('viewInfluencers', item.status)"
                  @click="getPairedInfluencers(item)"
                  color="success"
                  class="ims-action"
                >
                  <v-icon small data-toggle="tooltip" data-placement="top" title="View Influencers">people</v-icon>
                </v-btn> -->
              </td>
            </template>
            <template v-slot:no-data>No Data Received</template>
          </v-data-table>
        </div>
      </div>
    </section>
    <view-campaign-modal
      v-model="viewModalDialog"
      :value="viewModalDialog"
      :campaignData="viewCampaignData"
    />
    <influencer-elimination v-model="eliminationDialog" :campaingData="campaingData" />
    <!-- Cilent View Influencer Dialog -->
    <v-dialog v-model="viewInfluencerDialog" max-width="1250">
      <v-card>
        <v-card-title>
          <span class="headline">Paired influencers</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" lg="3" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Contents</v-card-title>
                  <v-card-subtitle>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Target : {{ campaignCOEB.min_content }} to {{ campaignCOEB.max_content }}</p>
                    <p class="pa-0 ma-0 custom-font">Current Total: {{measurement.total}}</p>
                    <p class="pa-0 ma-0 custom-font">Approved Total: {{measurement.invitedTotal}}</p>
                    <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedTotal}}</p>
                    <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.totalPercentage}} %</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Outreach</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaignCOEB.outreach | thousandSeprator}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Current Total: {{measurement.outreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Approved Total: {{measurement.invitedOutreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedOutreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.outreachPercentage}}%</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Engagement</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaignCOEB.engagement | thousandSeprator}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Current Total: {{measurement.engagement | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Approved Total: {{measurement.invitedEngagement | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedEngagement | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.engagementPercentage}}%</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
          </v-row>
        </v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Handle</th>
                <th class="text-left">Followers</th>
                <th class="text-left">Eng. Rate</th>
                <th class="text-left">Aud. Cred</th>
                <th class="text-left">Elimination Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in pairedInfluencers" :key="item.instagramHandle">
                <td>
                  <a :href="'https://www.tiktok.com/@' + item.instagramHandle" target="_blank" v-if="item.influencer_details.platform === 'tiktok'"><img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.instagramHandle }}</a>
                  <a :href="'https://youtube.com/' + item.instagramHandle" target="_blank" v-else-if="item.influencer_details.platform === 'youtube'"><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.instagramHandle }}</a>
                  <a :href="'https://instagram.com/' + item.instagramHandle" target="_blank" v-else><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.instagramHandle }}</a>

                </td>
                <td>{{ item.followers }}</td>
                <td>{{ item.engagement_rate }}%</td>
                <td>
                  <v-icon :color="item.audience_credibility_color">supervised_user_circle</v-icon>
                  {{ item.audience_credibility }}
                </td>
                <td>
                  <v-chip
                    class="ma-2"
                    :color="eliminatinStatusColor(item.eliminationStatus)"
                    v-on="on"
                    x-small
                    text-color="white"
                  >
                    {{ eliminationStatusDisplay(item.eliminationStatus) }}
                    <v-icon right x-small>mdi-check</v-icon>
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="viewInfluencerDialog = false">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End of Client View Influencer Dialog -->
  </div>
</template>

<script>
import moment from 'moment'
import campaignAPIs from './campaignAPIs'
import pairingAPIs from '../Pairing/pairingAPIs';
// import clientAPIs from '../Client/clientAPIs'
import campaignHelper from './campaignHelper';
import config from '@/config'
import campaignConfig from './config'
import ViewCampaignModal from './ViewCampaignModal'
import InfluencerElimination from './ViewPairingInfluencerElimination.vue'
import campaignPDF from './campaignPDF'
import { mapState } from 'vuex'
import utils from '../../../utils'
import reverse from 'lodash/reverse'

export default {
  name: 'campaign-brief',
  components: {
    ViewCampaignModal,
    InfluencerElimination
  },
  data() {
    return {
      viewModalDialog: false,
      campaingData: null,
      eliminationDialog: false,
      currentPage: 1,
      itemsPerPage: 10,
      totalRows: 0,
      campaigns: [],
      keyword: '',
      fields: [
        {
          text: 'Campaign Name',
          value: 'name'
        },
        {
          text: 'Status',
          value: 'campaignStatusDisplayForClients'
        },
        // {
        //   text: 'Updated On',
        //   value: 'updatedAtDisplay'
        // },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      viewCampaignData: null,
      viewInfluencerDialog: false,
      campaignCOEB: {},
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      }
    };
  },
  mounted() {
    // clientAPIs
    //   .getClient(this.user.clientID)
    //   .then(response => {
    //     let client = response
    //     if (!client.acceptTerms) {
    //       this.$swal({
    //         title: 'Complete the Vendor Creation Form',
    //         type: 'info',
    //         text: 'You need to complete the vendor creation form and accept the terms to continue.'
    //       }).then(() => this.$router.push({path: '/client/vendor-creation-form'}))
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
  },
  created() {
    this.paginate(1);
  },
  watch: {
    currentPage() {
      this.paginate(this.currentPage);
    }
  },
  methods: {
    async startEliminate(campaignID, status) {
      let result = null
      if (status === this.campaignStatusConfig.COMPLETE) {
        // complete stage no need confirmation
        result = { value: true }
      } else {
        result = await this.$swal({
          title: campaignConfig.campaignConfirmation.pairingTermsAndCondition.title,
          html: campaignConfig.campaignConfirmation.pairingTermsAndCondition.html,
          type: 'info',
          width: 500,
          backdrop: `rgba(0,0,1, 0.9)`,
          showCancelButton: true,
          confirmButtonText: campaignConfig.campaignConfirmation.pairingTermsAndCondition.confirmButtonText,
          cancelButtonText: campaignConfig.campaignConfirmation.pairingTermsAndCondition.cancelButtonText,
          allowOutsideClick: false
        })
      }
      if (!result.value) {
        this.eliminationDialog = false;
      } else {
        campaignAPIs
        .getCampaign(campaignID)
        .then(response => {
          this.campaingData = Object.assign({}, response);
          this.eliminationDialog = true;
        })
        .catch(error => {
          console.log('error', error);
        });
      }
    },
    paginate(page = 1) {
      this.currentPage = page;
      campaignAPIs
        .paginate({
          page: page,
          keyword: this.keyword,
          sort: 'updatedAt DESC'
        })
        .then(response => {
          let campaigns = response.campaigns.map(item => {
            item.campaignStatusDisplayForClients = campaignConfig.campaignStatusDisplayForClients[item.status];
            // if clientPaymentStatus is undefined, we will use Campaign activation Status for compability
            item.clientPaymentStatusDisplay = item.clientPaymentStatus
              ? campaignConfig.clientPaymentStatusDisplay[item.clientPaymentStatus]
              : campaignConfig.clientPaymentStatusDisplay[item.activated];
            item.updatedAtDisplay = this.formatTime(item.updatedAt);
            return item;
          });

          this.campaigns = campaigns;
          this.totalRows = response.totalCampaigns;
          this.checkShowURLParam()
        })
        .catch(error => {
          console.log('error', error);
        });
    },

    getCampaignDataToView(campaignID) {
      campaignAPIs
        .getCampaign(campaignID)
        .then(response => {
          this.viewCampaignData = response;
          this.viewModalDialog = true;
        })
        .catch(error => {
          this.viewModalDialog = true;
          // Request failed.
          console.log('error', error);
        });
    },
    approveCampaign(campaignID) {
      // Get campaign confirmation configuration
      var campaignConfirmation = campaignConfig.campaignConfirmation.approval[this.campaignStatusConfig.PENDING_CLIENT_APPROVAL];

      // Display confirmation box
      this.$swal({
        title: campaignConfirmation['confirmation']['title'],
        html: campaignConfirmation['confirmation']['html'],
        input: campaignConfirmation['confirmation']['input'],
        inputValue: 0,
        inputPlaceholder: 'I have read and agree to the Terms and Conditions',
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        inputValidator: result => {
          return !result && 'You need to agree with T&C';
        },
        width: 850,
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return campaignAPIs
            .approveCampaign(campaignID, this.campaignStatusConfig.PENDING_CLIENT_APPROVAL)
            .then(response => {
              // convert campaign into base64 encoding data
              campaignAPIs
                .getCampaign(campaignID)
                .then(response => {
                  campaignPDF
                    .getPdfInBase64(response)
                    .then(pdfData => {
                      this.sendEmail(campaignID, pdfData);
                    })
                    .catch(error => {
                      console.log('error in converting PDF', error);
                    });
                })
                .catch(error => {
                  // Request failed.
                  console.log('error', error);
                });
              return response;
            })
            .catch(error => {
              // Request failed.
              console.log('error', error);

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Refresh campaign list
          this.paginate(1);

          // Delete local data for the new status list to force refresh
          this.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: campaignConfig.campaignStatusFlow['approve'][this.campaignStatusConfig.PENDING_CLIENT_APPROVAL],
            data: null
          });

          // Show success message
          this.$swal({
            title: campaignConfirmation['confirm']['title'],
            text: campaignConfirmation['confirm']['text'],
            type: 'success'
          });
        } else {
          // Do nothing for now
        }
      });
    },
    buttonShow(type, campaignStatus = null) {
      const buttonPermission = config['userPermissions']['campaign'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(campaignStatus);
      }
      return false;
    },
    async getPairedInfluencers(campaign) {
      const campaignResp = await campaignAPIs.getCampaign(campaign.id)
      if (campaignResp) {
        this.campaignCOEB = Object.assign(
          {},
          {
            id: campaignResp.id,
            campaignId: campaignResp.id,
            campaignName: campaignResp.name,
            campaignType: campaignResp.campaignType,
            companyID: campaignResp.companyID,
            clientID: campaignResp.clientID,
            ioNumbers: campaignResp.ioNumbers,
            campaignOutreach: campaignResp.outreach,
            campaignEngagement: campaignResp.engagement,
            campaignBudget: campaignResp.budget,
            max_content: campaignResp.max_content,
            min_content: campaignResp.min_content,
            outreach: campaignResp.outreach,
            engagement: campaignResp.engagement,
            budget: campaignResp.budget
          }
        )
      }
      const pairingResp = await pairingAPIs.getPairedInfluencersByCampaign(campaign.id)
      if (pairingResp) {
        let items = [];
        for (let data of pairingResp) {
          let inf = this.beautifyData(data);
          // if (inf.eliminationStatus === campaignConfig.eliminationStatus.SELECTED) {
          //   items.push(inf);
          // }
          if (inf.pairingStatus === campaignConfig.pairingStatus.ACCEPTED) {
            items.push(inf);
          }
        }
        this.pairedInfluencers = Object.assign([], items);
        this.campaignMeasurement(items)
        /**
         * #NOTE
         * filter invited influencer list
         */
        const invitedItems = items
        .filter(e => e.pairingStatus !== campaignConfig.pairingStatus.ELIMINATION_PENDING)
        this.campaignMeasurementInvited(invitedItems)

        /**
         * #NOTE
         * filter not invited influencer list
         */
        const notInvitedItems = items
        .filter(e => e.pairingStatus === campaignConfig.pairingStatus.ELIMINATION_PENDING)
        this.campaignMeasurementNotInvited(notInvitedItems)
        this.viewInfluencerDialog = true;
      }
    },
    campaignMeasurement(items) {
      // console.log('Campaign Outreach', this.campaignCOEB.outreach)
      this.measurement.total = 0
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(item => {
        this.measurement.total += Number(this.calculateContents(item))
        this.measurement.outreach += Number(this.calculateOutreach(item));
        this.measurement.engagement += Number(this.calculateEngagement(item));
        this.measurement.budget += Number(item.payout || 0);
      })
      let content = (this.measurement.total / (this.campaignCOEB.min_content || this.campaignCOEB.min_influencer || 1)) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = ((this.measurement.outreach / this.campaignCOEB.outreach) * 100).toFixed(2);
      this.measurement.engagementPercentage = ((this.measurement.engagement / this.campaignCOEB.engagement) * 100).toFixed(2);
      this.measurement.cogsPercentage = ((this.measurement.budget / this.budget) * 100).toFixed(2);
    },
    campaignMeasurementInvited(items) {
      this.measurement.invitedTotal = 0
      items.map(item => {
        this.measurement.invitedTotal += Number(this.calculateContents(item))
        this.measurement.invitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.invitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.invitedBudget += Number(item.payout || 0);
      })
    },
    campaignMeasurementNotInvited(items) {
      this.measurement.notInvitedTotal = 0
      items.map(item => {
        this.measurement.notInvitedTotal += Number(this.calculateContents(item))
        this.measurement.notInvitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.notInvitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.notInvitedBudget += Number(item.payout || 0);
      })
    },
    calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels;
    },
    calculateOutreach(item) {
      const followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    calculateEngagement(item) {
      const engagement = item.engagement;
      return engagement * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    beautifyData(data) {
      let inf = {};
      const influencerDetails = data.influencer_details;
      const deliverablesDetails = data.deliverables_details || {};
      inf = data.influencer_details;
      inf.influencer_details = utils.func.refreshJSON(influencerDetails)
      inf.pairing_details = data.pairing_details
      inf.elimination_details = data.elimination_details
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.remarks = data.additional_details ? data.additional_details.remarks : '';
      inf.CampaignID = this.campaignCOEB ? this.campaignCOEB.campaignId : '';
      inf.CampaignName = this.campaignCOEB ? this.campaignCOEB.campaignName : '';
      inf.pairingID = data.id;
      inf.id = data.id;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.deliverables = campaignHelper.getDeliverableDetails(deliverablesDetails)
      if (data.payout_details) {
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
        inf.history = data.payout_details.history ? reverse(data.payout_details.history) : [];
        inf.payoutStatus = data.payout_details.status || 0;
        if (inf.payoutStatus === campaignConfig.payoutStatus.SUBMITTED) {
          inf.payoutSubmitted = true
        }
        if (inf.payoutStatus >= campaignConfig.payoutStatus.CONFIRMED) {
          inf.payoutVerified = true
        }
      }
      if (data.brief_details) {
        inf.brief_details = data.brief_details
      }
      return inf;
    },
    eliminatinStatusColor(id) {
      if (id === 0) {
        return 'primary'
      } else if (id === 1) {
        return '#8BC34A'
      } else {
        return 'red'
      }
    },
    eliminationStatusDisplay(id) {
      if (id === 0) {
        return 'Pending'
      } else if (id === 1) {
        return 'Selected'
      } else {
        return 'Eliminated'
      }
    },
    // send pdf in email
    sendEmail(campaignID, pdfData) {
      campaignAPIs
        .sendCampaignPDF(campaignID, pdfData)
        .then(response => {
          return response;
        })
        .catch(error => {
          console.log('error in sending email with pdf attached', error);
        });
    },
    formatTime(value) {
      return moment(value).fromNow();
    },
    checkShowURLParam() {
      if (this.$route.query.id) {
        this.getCampaignDataToView(this.$route.query.id)
      }
    }
  },
  computed: {
    ...mapState(['user']),
    campaignActivationStatusConfig: function() {
      return campaignConfig.campaignActivationStatus;
    },
    campaignStatusConfig: function() {
      return config.campaignStatus;
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role);
    }
  }
};
</script>



// WEBPACK FOOTER //
// CampaignBrief.vue?6ac77a1b